interface MoveContentProps {
  movementRef: React.RefObject<HTMLElement>;
  complementsRef?: React.MutableRefObject<HTMLElement | null>;
  newQuantity: number;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
}

interface MoveUpProps {
  movementSection: HTMLElement;
  complementsSection: HTMLElement;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
}

export const moveUp = ({ complementsSection, movementSection, setComplementBlockIsUp }: MoveUpProps) => {
  const dividerBeforeCssStyle = window.getComputedStyle(complementsSection, '::before');
  const dividerSize =
    parseFloat(dividerBeforeCssStyle.marginBottom) + parseFloat(dividerBeforeCssStyle.borderWidth);

  const pureComplementsHeight = complementsSection.clientHeight - Math.round(dividerSize);
  const miscHeight = movementSection.clientHeight + Math.round(dividerSize / 2);

  complementsSection.style.top = `-${miscHeight}px`;
  movementSection.style.top = `${pureComplementsHeight}px`;

  setComplementBlockIsUp(true);
};

export const moveContent = async ({
  movementRef,
  complementsRef,
  newQuantity,
  setComplementBlockIsUp,
}: MoveContentProps) => {
  const complementsSection = complementsRef?.current;
  const movementSection = movementRef?.current;

  if (!complementsSection || !movementSection) return;

  const isCurrentlyUp = complementsSection.style.top && complementsSection.style.top !== '0px';

  if (newQuantity > 0) {
    if (isCurrentlyUp) return;
    moveUp({ complementsSection, movementSection, setComplementBlockIsUp });
  } else if (newQuantity === 0) {
    if (!isCurrentlyUp) return;
    complementsSection.style.top = '0px';
    movementSection.style.top = '0px';
    setComplementBlockIsUp(false);
  }
};
